import { client } from './client'
import {
  AdminMetricsEntry,
  AdminMetricsBootstrapResponse,
  AdminMetricsPausesResponse,
  AdminSavedInstallmentsFilters,
  AdminSavedInstallmentsSummary,
  BasicEmployeesResponse,
  EmployeeSearchResponse
} from '@views/adminMetrics/types'

export const bootstrapAdminHoursMetricsService = async (cocap: string): Promise<AdminMetricsBootstrapResponse> => {
  const { data } = await client.post(
    '/time-tracker/admin-metrics/bootstrap',
    {},
    {
      headers: {
        cocap
      }
    }
  )

  return data
}

export const searchEmployeesByNameService = async (
  searchQuery: string,
  cocap: string
): Promise<EmployeeSearchResponse> => {
  const { data } = await client.get(`/person/query?name=${encodeURIComponent(searchQuery)}`, {
    headers: {
      cocap
    }
  })

  return data
}

export const getAdminMetricsEntriesService = async (
  params: {
    mode: 'day' | 'week' | 'month'
    referenceDate?: string
    referenceMonth?: string
    userId?: string | null
  },
  cocap: string
): Promise<{ entries: AdminMetricsEntry[] }> => {
  const { data } = await client.get('/time-tracker/admin-metrics/entries', {
    headers: {
      cocap
    },
    params
  })

  return data
}

export const getEmployeesByIdsService = async (ids: string[], cocap: string): Promise<BasicEmployeesResponse> => {
  const { data } = await client.get(`/person/basic?ids=${encodeURIComponent(ids.join(','))}`, {
    headers: {
      cocap
    }
  })

  return data
}

export const getAdminMetricsPausesService = async (
  entryIds: string[],
  cocap: string
): Promise<AdminMetricsPausesResponse> => {
  const { data } = await client.get('/time-tracker/admin-metrics/pauses', {
    headers: {
      cocap
    },
    params: {
      entryIds: entryIds.join(',')
    }
  })

  return data
}

export const getAdminSavedInstallmentsSummaryService = async (
  cocap: string,
  filters?: AdminSavedInstallmentsFilters
): Promise<AdminSavedInstallmentsSummary> => {
  const params = !filters
    ? {}
    : {
        ...(filters.mode === 'year' && filters.year ? { year: filters.year } : {}),
        ...(filters.mode === 'month' && filters.month ? { month: filters.month } : {}),
        ...(filters.mode === 'custom_range' && filters.startDate && filters.endDate
          ? {
              startDate: filters.startDate,
              endDate: filters.endDate
            }
          : {}),
        ...(filters.bank ? { bank: filters.bank } : {})
      }

  const { data } = await client.get('/time-tracker/admin-metrics/saved-installments', {
    headers: {
      cocap
    },
    params
  })

  return data
}
